import { getAppId } from 'src/core/classes/helpers/getAppId'

const appId = getAppId()

export const StorageKeys = {
  sitePages: `_hp_${appId}_site_pages`,
  settings: `_hp_${appId}_settings`,
  user: `_hp_${appId}_account`,
  widgets: `_hp_${appId}_widgets`,
  roles: `_hp_${appId}_roles`,
  languages: `_hp_${appId}_languages`,
  markets: `_hp_${appId}_markets`,
  locales: `_hp_${appId}_locales`,
  organisations: `_hp_${appId}_organisations`,
  salutations: `_hp_${appId}_salutations`,
  associativeLanguages: `_hp_${appId}_associative_languages`,
  countriesCode: `_hp_${appId}_countries_code`,
  countries: `_hp_${appId}_countries`,
  countriesGroups: `_hp_${appId}_countriesGroups`,
  logoData: `_hp_${appId}_logoData`,
}

export default StorageKeys
